import CryptoJS from 'crypto-js'

export default class Encryption {
    static encrypt(data) {
        try {
            // Obtenemos la clave y la procesamos
            let key = process.env.MIX_APP_KEY
            key = key.replace('base64:', '')

            // Convertimos el objeto a string
            const dataString = JSON.stringify(data)

            // Creamos el IV
            const iv = CryptoJS.lib.WordArray.random(16)

            // Configuración de la encriptación
            const options = {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }

            // Encriptamos
            const encrypted = CryptoJS.AES.encrypt(dataString, CryptoJS.enc.Base64.parse(key), options)

            // Retornamos los datos necesarios para desencriptar
            return {
                data: encrypted.toString(),
                iv: CryptoJS.enc.Base64.stringify(iv),
            }
        } catch (error) {
            console.error('Error en encriptación:', error)
            throw error
        }
    }
}
